<template>
  <div class="sc-values">
    <img class="sc-values-flag" src="@/assets/sc/flag.png" alt="">
    <div class="container">
      <h2 class="sc-title -center -margin-bottom">Prečo Wüstenrot</h2>
      <div class="row">
        <div
          v-for="(item, i) in values"
          :key="i"
          class="column -md3"
        >
          <ValueItem
            :item="item"
            sales
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import values from '@/data/valuesSales';

import ValueItem from '@/components/UValueItem.vue';

export default {
  components: {
    ValueItem,
  },
  data() {
    return {
      values,
    };
  },
};
</script>

<style lang="scss" scoped>
.sc-values {
  padding: 50px 0;
  position: relative;
  .sc-values-flag {
    display: none;
  }
  @media screen and (min-width: $screen-md) {
    padding: 100px 0;
    .sc-values-flag {
      display: block;
      position: absolute;
      left: calc(50vw + 80px);
      top: -300px;
      width: 800px;
      height: auto;
      right: 0;
      pointer-events: none;
    }
  }
}
</style>
